"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAnnouncements = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAnnouncements = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n\n  > button {\n    position: relative;\n    padding: 0;\n    background-color: ", ";\n    width: 32px;\n    height: 32px;\n    ", ";\n    color: ", ";\n\n    i {\n      ", ";\n      color: ", ";\n      font-size: ", ";\n    }\n\n    .not-expired {\n      position: absolute;\n      background-color: ", ";\n      border-radius: ", ";\n      height: 6px;\n      margin-right: ", ";\n      width: 6px;\n      bottom: 10%;\n      right: 15%;\n    }\n  }\n"], ["\n  margin: ", ";\n\n  > button {\n    position: relative;\n    padding: 0;\n    background-color: ", ";\n    width: 32px;\n    height: 32px;\n    ", ";\n    color: ", ";\n\n    i {\n      ", ";\n      color: ", ";\n      font-size: ", ";\n    }\n\n    .not-expired {\n      position: absolute;\n      background-color: ", ";\n      border-radius: ", ";\n      height: 6px;\n      margin-right: ", ";\n      width: 6px;\n      bottom: 10%;\n      right: 15%;\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.normal;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.normal;
}, function (_a) {
    var Iconology = _a.theme.Iconology;
    return Iconology.Sizes.sm;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.danger;
}, function (props) { return props.theme.Dimensions.Borders.Radiuses.circle; }, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
});
var templateObject_1;
